import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { PartnerModel, SendDocument, STATUS_PARTNER } from 'Pages/prelogin'
import { serialize } from 'object-to-formdata'

export const preloginApi = {
	updatePartner: async (id: string, data: Partial<PartnerModel>) => {
		const res = await axiosDS().patch<PartnerModel>(`${urls.prelogin.index}/${id}`, { data })
		return res.data
	},
	getPartner: async (id: string) => {
		const res = await axiosDS().get<PartnerModel>(`${urls.prelogin.index}/${id}`)
		return res.data
	},
	deleteDocument: async (id: number, partnerId: string) => {
		const res = await axiosDS().delete<PartnerModel>(
			`${urls.prelogin.index}/${partnerId}/document/${id}`
		)
		return res.data
	},
	createDocument: async (data: SendDocument) => {
		const res = await axiosDS().post<PartnerModel>(
			`${urls.prelogin.index}/${data?.partner_id}/document/${data?.document_type}`,
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
	setStatus: async (id: string, status: STATUS_PARTNER) => {
		const res = await axiosDS().patch<PartnerModel>(
			`${urls.prelogin.index}/${id}/set_status/${status}`
		)
		return res.data
	},
}
